// extracted by mini-css-extract-plugin
export var filterIncDec = "_9e-0";
export var leftBorder = "_9e-1";
export var rightBorder = "_9e-2";
export var stringInput = "_9e-3";